module.exports = __webpack_public_path__ + "5a0f20b660cfd3c21ee4cb90964a5c10.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bird-food.png
// module id = 179
// module chunks = 0